<template>
  <div class="performance">
    <div class="performance__header">
      <h2 class="performance__header__title medium-title">Team Performance</h2>
    </div>
    <div class="performance__action">
      <div class="performance__action__filter">
        <div class="performance__action__filter__from">
          <label class="performance__action__filter__from__label small-font" for="start-date">From</label>
          <v-date-picker
            v-model="selectedStart"
            popoverVisibility="focus"
            :input-props="{
              id: 'start-date',
              class: 'start-date',
              placeholder: 'Select date',
              readonly: true,
            }"
            class="from-date"
          />
        </div>
        <div class="performance__action__filter__to">
          <label class="performance__action__filter__to__label small-font" for="start-date">To</label>
          <v-date-picker
            v-model="selectedEnd"
            popoverVisibility="focus"
            :input-props="{
              id: 'end-date',
              class: 'end-date',
              placeholder: 'Select date',
              readonly: true,
            }"
            class="to-date"
          />
        </div>
      </div>
      <div class="performance__action__submit_filter">
        <button class="primary btn-regular" @click.stop="submitFilter()" :disabled="isLoading">Submit</button>
      </div>
    </div>
    <div v-if="!isLoading" class="performance__main">
      <table v-if="teamPerformances.length > 0" class="table-performance">
        <tr>
          <th>Assignee</th>
          <th>Closed Ticket</th>
          <th>Avg of Res. Time (hour)</th>
        </tr>
        <tr v-for="team in teamPerformances" :key="team.id">
          <td class="center">{{ team.full_name }}</td>
          <td class="center">{{ team.total_closed }}</td>
          <td class="center">{{ team.avg_res_time }}</td>
        </tr>
      </table>
      <div v-else class="performance__main__empty">
        <adx-empty />
      </div>
    </div>
    <div v-else class="performance__loading">
      <adx-loading />
    </div>
  </div>
</template>

<script>
import calendar from 'v-calendar'
import moment from 'moment'

import Loading from '@/components/Loading/Primary'
import Empty from '@/components/NotFound/Selection'
import api from '@/api'
import { apiV2 } from '@/api/urls'

export default {
  name: 'adx-task-performance',
  components: {
    'adx-loading': Loading,
    'adx-empty': Empty
  },
  props: {

  },
  data() {
    return {
      teamPerformances: [],
      isLoading: false,
      selectedStart: this.getStartDate(),
      selectedEnd: this.getEndDate(),
    }
  },
  computed: {
    attr() {
      return [
        {
          highlight: {
            backgroundColor: 'red'
          }
        }
      ]
    }
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {
    this.getTeamPerformance()
  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    getTeamPerformance() {
      (async () => {
        this.isLoading = true
        let startDate = moment(this.selectedStart).format('YYYY-MM-DD')
        let endDate = moment(this.selectedEnd).format('YYYY-MM-DD')
        let param = {
          start: startDate,
          end: endDate
        }
        const response = await api.get(apiV2.teamPerformance, { needToken: true, params: param })
        if (response.status == 200) {
          this.teamPerformances = response.data
        }

        this.isLoading = false
      })();
    },
    getStartDate() {
      let now = moment().utcOffset(7)
      let firstDate = moment([now.year(), now.month()])
      return firstDate.toDate()
    },
    getEndDate() {
      return moment().utcOffset(7).toDate()
    },
    submitFilter() {
      this.getTeamPerformance()
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>